<template>
  <v-data-table
      :show-select="checkable"
      dense
      item-key="id"
      class="decreased-fontsize-table rights-table"
      v-model="checked"
      @input="$emit('update:checkedItems', $event)"
      @update:options="clearChecked"
      :page.sync="currentPage"
      :items="itemsList"
      :loading="items === null || portionLoading"
      :headers="headers"
      :items-per-page.sync="itemsPerPage"
      :footer-props="{
        itemsPerPageOptions: [50, 100, 200, 500, 2000, 5000],
        pageText: totalCount ? `{0}-{1} / ${totalCount}` : (continuosAmount ? `{0}-{1} / ${itemsList.length -  1}+` : '$vuetify.dataFooter.pageText')
      }"
      :item-class="(item) => (item ? 'non-empty' : 'empty')"
  >

    <template v-slot:item.revoke="{item}">
      <v-tooltip v-if="String(item.revoke) === 'true'" top>
        <template v-slot:activator="{on}">
          <v-icon v-on="on">mdi-undo</v-icon>
        </template>
        Revoke
      </v-tooltip>
    </template>

    <template v-slot:item.hasError="{item}">
      <v-tooltip v-if="item.hasError" right>
        <template v-slot:activator="{on, attrs}">
          <span @mousemove="loadErrors(item)">
            <v-icon v-on="on" v-bind="attrs" color="red">mdi-alert</v-icon>
          </span>
        </template>
        <div v-if="errors[String(item.id)]">
          <div v-for="err in errors[String(item.id)]" :key="err.en">
            {{err[$i18n.locale]}}
          </div>
        </div>
        <v-progress-circular color="primary" indeterminate v-else/>
      </v-tooltip>

      <v-icon v-else color="green">mdi-check</v-icon>
    </template>

    <template v-slot:item.actions="{item}">
      <slot name="actions" :row="item"></slot>
    </template>

    <template v-slot:item.claimEndDate="{item}">
      <span v-if="item && ((item.claimEndDate && item.claimEndDate==='1900-01-01') || String(item.revoke) === 'true')">-</span>
      <span v-else-if="item && item.claimEndDate">{{item.claimEndDate}}</span>
      <span v-else>-</span>
    </template>

    <template v-slot:item.claimStartDate="{item}">
      <span v-if="item && ((item.claimStartDate && item.claimStartDate==='1900-01-01') || String(item.revoke) === 'true')">-</span>
      <span v-else-if="item && item.claimStartDate">{{item.claimStartDate}}</span>
      <span v-else>-</span>
    </template>

    <template v-slot:item.internationalCollection="{item}">
      <span v-if="item.internationalCollection">
        <v-icon>mdi-toggle-switch</v-icon>
      </span>
      <span v-else> 
        <v-icon>mdi-toggle-switch-off-outline</v-icon>
      </span>
    </template>

    <template v-slot:item.type="{item}">
      <v-tooltip top v-if="item">
        <template v-slot:activator="{on, attrs}">
          <span v-on="on" v-bind="attrs">
            <v-icon v-if="String(item.type) === '1'" >mdi-volume-high</v-icon>
            <v-icon v-else-if="String(item.type) === '2'" >mdi-video</v-icon>
          </span>
        </template>
        <span v-if="String(item.type) === '1'">{{ $t('rights.types.audio') }}</span>
        <span v-if="String(item.type) === '2'">{{ $t('rights.types.video') }}</span>
      </v-tooltip>
    </template>

    <template v-slot:item.status="{item}">
      <v-tooltip top v-if="item.status == 'DC'">
        <template v-slot:activator="{on, attrs}">
          <span v-on="on" v-bind="attrs">
            {{ item.status }}
          </span>
        </template>
        <p v-if="item.dc" class="mb-0">{{$t('rights.status.dc-claimedby')}}: {{ item.dc }}</p>
        <p class="my-0">{{$t('rights.status.dc-intersection')}}: {{ item.dcfdat }} - {{ item.dctdat }}</p>
      </v-tooltip>
      <span v-else>
        {{ item.status }}
      </span>
    </template>

  </v-data-table>
</template>

<script>
export default {
  name: "RightsTable",
  props: {
    items: Array,
    displayedColumns: Array,
    checkedItems: Array,
    continuosAmount: Boolean,
    checkable: {
      type: Boolean,
      default: true
    },
    portionLoading: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    totalCount: {
      type: [Number, Object],
      default: () => null,
    }
  },
  data() {
    return {
      checked: [],
      itemsPerPage: 100,
      currentPage: 1,
    }
  },
  watch: {
    checkedItems(v) {
      this.checked = v;
    },
    currentPage() {
      if (this.currentPage === (this.lastPage + 1)) {
        if (this.continuosAmount && this.lastPage > 0) {
          this.$emit('load-more');
        }
      }
    }
  },
  methods: {
    loadErrors(item) {
      this.$emit('load-errors', item)
    },
    clearChecked() {
      this.checked = []
    }
  },
  computed: {
    itemsList() {
      return this.items || [];
    },
    lastPage() {
      return Math.ceil((this.items.length - Number(this.continuosAmount)) / this.itemsPerPage);
    },
    headers() {
      const unsortable = ['actions'];
      const getCol = (value) => ({
        value,
        text: this.$t(`rights.columns.${value}`),
        sortable: !unsortable.includes(value)
      });
      return this.displayedColumns.map(getCol)
    }
  }
}
</script>

<style>
.rights-table .v-data-table__wrapper tbody tr:not(.non-empty, .v-data-table__empty-wrapper) {
  display: none;
}
</style>